// extracted by mini-css-extract-plugin
export default {"wrapper":"A_Tag_wrapper__Y1nvQ","label":"A_Tag_label__AMMFK"};